// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"94f1ef4d","455":"91e0194c","977":"8d4d28cd"}[chunkId] + ".chunk.js";
};